import React from "react";

import {
  SubscriptionSummary as SubscriptionSummaryType,
} from "./dashboardType";

interface Props {
  data: SubscriptionSummaryType;
}

const SubscriptionSummary: React.FC<Props> = ({
  data,
}) => {
  const items = [
    ["Active", data.Active],
    ["Expired", data.Expired],
    [
      "Starting Tomorrow",
      data.Starting_Tomorrow,
    ],
    [
      "Starting Next 7 Days",
      data.Starting_Next_7_Days,
    ],
    [
      "Expiring 0-3 Days",
      data.Expiring_0_3_Days,
    ],
    [
      "Expiring 4-7 Days",
      data.Expiring_4_7_Days,
    ],
    [
      "Expiring 8-15 Days",
      data.Expiring_8_15_Days,
    ],
    [
      "Expiring 16-30 Days",
      data.Expiring_16_30_Days,
    ],
    [
      "Verification Pending",
      data.Verification_Pending,
    ],
    [
      "Verification Completed",
      data.Verification_Completed,
    ],
    [
      "Payment Pending",
      data.Payment_Pending,
    ],
    [
      "Payment Paid",
      data.Payment_Paid,
    ],
  ];

  return (
    <section className="rounded-xl border bg-white p-5 shadow-sm">
      <h2 className="mb-4 text-lg font-semibold">
        Subscriptions
      </h2>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 xl:grid-cols-4">
        {items.map(
          ([label, value]) => (
            <div
              key={String(label)}
              className="rounded-lg border p-4"
            >
              <p className="text-sm text-gray-500">
                {label}
              </p>

              <p className="mt-1 text-xl font-bold">
                {value}
              </p>
            </div>
          )
        )}
      </div>
    </section>
  );
};

export default SubscriptionSummary;